import { render, staticRenderFns } from "./programmeCard.vue?vue&type=template&id=1b2ac9c6&scoped=true&"
import script from "./programmeCard.vue?vue&type=script&lang=js&"
export * from "./programmeCard.vue?vue&type=script&lang=js&"
import style0 from "./programmeCard.vue?vue&type=style&index=0&id=1b2ac9c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2ac9c6",
  null
  
)

export default component.exports